import Opening from "./Opening";
export default Opening;